import { render, staticRenderFns } from "./SamLoader.vue?vue&type=template&id=061b6f53&scoped=true&"
import script from "./SamLoader.vue?vue&type=script&lang=js&"
export * from "./SamLoader.vue?vue&type=script&lang=js&"
import style0 from "./SamLoader.vue?vue&type=style&index=0&id=061b6f53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b6f53",
  null
  
)

export default component.exports